/*
 =========================================================
 * Vue Black Dashboard - v1.1.2
 =========================================================

 * Product Page: https://www.creative-tim.com/product/black-dashboard
 * Copyright 2023 Creative Tim (http://www.creative-tim.com)

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

 */
import Vue from "vue";
import VueRouter from "vue-router";
import RouterPrefetch from 'vue-router-prefetch'
import App from "./App";
// TIP: change to import router from "./router/starterRouter"; to start with a clean layout
import router from "./router/index";

import BlackDashboard from "./plugins/blackDashboard";
import i18n from "./i18n"
import './registerServiceWorker'

import axios from './axios'

import {
  applyPolyfills,
  defineCustomElements,
} from '@aws-amplify/ui-components/loader';

import Amplify from 'aws-amplify';
import awsconfig from './aws-exports';

Amplify.configure(awsconfig);

applyPolyfills().then(() => {
  defineCustomElements(window);
});

Vue.config.ignoredElements = [/amplify-\w*/];

import VueSweetalert2 from "vue-sweetalert2"; //importa a lib
import "sweetalert2/dist/sweetalert2.min.css"; //configura css
Vue.use(VueSweetalert2); //usa a biblioteca

// import $ from 'jquery'
// require('datatables.net-bs')(window, $)
// import VueResource from 'vue-resource'
// import VueDataTables from 'datatables.net-bs'

//API AWS
// Vue.prototype.$API = 'https://s4m79qhd0l.execute-api.us-east-1.amazonaws.com/prod/'
// Vue.prototype.$API = 'https://s4m79qhd0l.execute-api.us-east-1.amazonaws.com/sec/'


import VueGoodTablePlugin from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css'
Vue.use(VueGoodTablePlugin);

Vue.use(BlackDashboard);
Vue.use(VueRouter);
Vue.use(RouterPrefetch);
// Vue.use(VueResource)
// Vue.use(VueDataTables)

/* eslint-disable no-new */
new Vue({
  router,
  axios,
  i18n,
  render: h => h(App)
}).$mount("#app");
